// extracted by extract-css-chunks-webpack-plugin
module.exports = {"qrCode":"qrCode-3Ool0ruP","closeBtn":"closeBtn-4AlsLXx3"};